import { useMutation, useQuery } from '@apollo/client';
import { InvoiceTransactionListTable } from '@nile/client_management/src/Pages/Invoice/InvoiceTransactionListTable';
import {
  Column,
  CustomModal,
  Row,
  COMMON_CONSTANTS,
  useActivityTracker
} from '@nile/components';
import { AccountClient } from '@nile/graphql';
import { DELETE_PAYMENT } from '@nile/graphql/src/Mutation/partialPayments';
import {
  Button,
  DisplayText,
  Page,
  TextStyle
} from '@superops/ui-design-system';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { GET_PAYMENT } from '@nile/graphql/src/Query/client_management/partialPayments';

export function DeletePaymentModal({ open, onClose, data, onSuccess }) {
  const [deletePayment, { loading: deletePaymentLoading }] = useMutation(
    DELETE_PAYMENT,
    {
      client: AccountClient
    }
  );

  const { data: paymentData, loading } = useQuery(GET_PAYMENT, {
    fetchPolicy: COMMON_CONSTANTS.CACHE_POLICIES.NO_CACHE,
    variables: { input: { paymentId: data?.paymentId } },
    client: AccountClient
  });

  return (
    <CustomModal open={open} onClose={onClose} zIndex={1}>
      <div className="w900">
        <Page
          variant="primary"
          contentHeight="120px"
          title={
            <TextStyle weight="Bold">
              <FormattedMessage id="invoice.partialPayments.deletePayment" />
            </TextStyle>
          }
          primaryAction={
            <Row gap={20}>
              <Button primary onClick={onClose} plainSecondary>
                <FormattedMessage id="common.cancel" />
              </Button>
              <Button
                primary
                onClick={async () => {
                  useActivityTracker({
                    event: 'PAYMENT_DELETE_CONFIRMED'
                  });
                  deletePayment({
                    variables: {
                      input: {
                        paymentId: data?.paymentId
                      }
                    }
                  })
                    .then((res) => {
                      if (res?.data?.deletePayment) {
                        onSuccess();
                      }
                    })
                    .finally(() => {
                      onClose();
                    });
                }}
                loading={deletePaymentLoading}
              >
                <FormattedMessage id="invoice.partialPayments.deletePayment" />
              </Button>
            </Row>
          }
        >
          <Column gap={20}>
            <div className="payment-li">
              <FormattedMessage
                id="invoice.partialPayments.deletePaymentConfirmation"
                values={{
                  b: (text) => (
                    <DisplayText element="p" size="large" weight="Bold">
                      {text}
                    </DisplayText>
                  ),
                  ul: (text) => <ul>{text}</ul>,
                  li: (text) => <li>{text}</li>
                }}
              />
            </div>
            <InvoiceTransactionListTable
              transactions={paymentData?.getPayment?.transactions || []}
              isEditable={false}
              hideDelete
              isLoading={loading}
            />
          </Column>
        </Page>
      </div>
    </CustomModal>
  );
}
